<div *ngIf="!IsPageLoaded; else populated;">
  <img src="https://dkzxkcjlbnjui.cloudfront.net/portal/loader/loading-page.gif" style="padding: 10% 35%;">
</div>
<ng-template #populated>
  <div class="cManikPopupWidth">
    <div class="main-content">
      <div class="cPopupContainer">
        <div [ngClass]="{'cPopupSidebar': GModel.ShowSectionList,'cPopupSidebarNarrow': !GModel.ShowSectionList}">
          <div class="cPopupMenu1">
            <ul class="nav">
              <li data-toggle="collapse" class="collapsed">
                <a matTooltip="Page settings" [matTooltipPosition]="'right'" (click)="PopulateMenu2('Page')">
                  <i class="fa fa-file-text" [ngClass]="{'active': GModel.IsPageSettingActive}"></i>
                </a>
              </li>
            </ul>
            <ul class="nav cPopupLowerUL">
              <li>
                <a matTooltip="Effects" [matTooltipPosition]="'right'" (click)="PopulateMenu2('Effects')">
                  <i class="fa fa-magic" [ngClass]="{'active': GModel.IsEffectsActive}"></i>
                </a>
              </li>
              <li *ngIf="AddBackgroundMedia">
                <a matTooltip="Background" [matTooltipPosition]="'right'" (click)="PopulateMenu2('Background')">
                  <i class="material-icons" [ngClass]="{'active': GModel.IsBackgroundActive}">pages</i>
                </a>
            </ul>
          </div>
        </div>
        <div *ngIf="GModel.IsPageLoaded"
          [ngClass]="{'cPopupMainPanel': GModel.ShowSectionList, 'cPopupMainPanelExpanded': !GModel.ShowSectionList}">
          <div class="cPopupWorkSpace" *ngIf="GModel.ShowPageSettings">
            <app-candid-photos [BusinessID]="GModel.BusinessID"></app-candid-photos>
          </div>
          <div class="cPopupWorkSpace cBackgroundMediaSettings" *ngIf="GModel.ShowBackgroundSettings">
            <image-handler [ImageData]="GModel.SmartMediaBG"></image-handler>
          </div>

          <div class="cPopupWorkSpace" *ngIf="GModel.AddEffects">
            <form [formGroup]="EffectForm" #rftForm="ngForm">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <div class="cMatdd_main"
                      [ngClass]="{'cMatdd_error': frmEft.SelectedEffectID.invalid && (frmEft.SelectedEffectID.touched || rftForm.submitted),'cMatdd_success': frmEft.SelectedEffectID.valid && frmEft.SelectedEffectID.dirty}">
                      <h5>Effects</h5>
                      <mat-select placeholder="Choose Effect" formControlName="SelectedEffectID">
                        <mat-option *ngFor="let item of DesignerEffects" [value]="item.DataValue">{{item.DataText}}
                        </mat-option>
                      </mat-select>
                      <span *ngIf="rftForm.submitted && frmEft.SelectedEffectID.errors" class="cErrorMsg">
                        <span *ngIf="frmEft.SelectedEffectID.errors.required">
                          *required</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <div class="cPopupAction">
              <button class="cButtonPopupSubmit" (click)="SubmitPageEffect($event)"></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>